import { AxiosInstance } from 'axios';
import { CompanyDrivenSettingRepository } from '@/model/repository/manager/attendance/CompanyDrivenSettingRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): CompanyDrivenSettingRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
    update(request) {
      return Repository.post(`${resource}`, request);
    },
  });
